/* eslint-disable prettier/prettier */
import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

import Client from "@/views/ClientModule/Client.vue";
import CreateEditClient from "@/components/ClientModule/CreateEdit.vue";
import ListOfClient from "@/components/ClientModule/List.vue";

import Supplier from "@/views/SupplierModule/Supplier.vue";
import CreateEditSupplier from "@/components/SupplierModule/CreateEdit.vue";
import ListOfSupplier from "@/components/SupplierModule/List.vue";

import PoRequest from "@/views/PoRequestModule/PoRequest.vue";
import CreateEditPoRequest from "@/components/PoRequestModule/CreateEdit.vue";
import ListOfPoRequest from "@/components/PoRequestModule/List.vue";
import ListForFinalApprovals from "@/components/PoRequestModule/ListForFinalApprovals.vue";

import TicketingForItem from "@/views/TicketingForItemModule/TicketingForItem.vue";
import CreateEditTicketingForItem from "@/components/TicketingForItemModule/CreateEdit.vue";
import ListOfTicketingForItem from "@/components/TicketingForItemModule/List.vue";

import SalesQuote from "@/views/SalesQuoteModule/SalesQuote.vue";
import CreateEditSalesQuote from "@/components/SalesQuoteModule/CreateEdit.vue";
import ListOfSalesQuote from "@/components/SalesQuoteModule/List.vue";

import PullOutToClient from "@/views/PullOutToClient/PullOutToClient.vue";
import CreateEditPullOutToClient from "@/components/PullOutToClient/CreateEdit.vue";
import ListOfPullOutToClient from "@/components/PullOutToClient/List.vue";

import Delivery from "@/views/Delivery/Delivery";
import CreateEditDelivery from "@/components/Delivery/CreateEdit";
import ListOfDelivery from "@/components/Delivery/List";

import Billing from "@/views/Billing/Billing";
import CreateEditBilling from "@/components/Billing/CreateEdit";
import ListOfBilling from "@/components/Billing/List";

import UserManagement from "@/views/UserManagement/UserManagement.vue";
import CreateEditUser from "@/components/UserManagement/CreateEdit.vue";
import CreateEditAgentQuota from "@/components/UserManagement/UserAgent/CreateEditAgentQuota.vue";
import ListOfUser from "@/components/UserManagement/List.vue";
import Login from "@/components/UserManagement/Login.vue";

import PurchaseOrder from "@/views/PurchaseOrderModule/PurchaseOrder.vue";
import CreateEditPurchaseOrder from "@/components/PurchaseOrderModule/CreateEdit.vue";
import CreateEditPurchaseOrder2 from "@/components/PurchaseOrderModule/CreateEdit2.vue";
import ListOfPurchaseOrder from "@/components/PurchaseOrderModule/List.vue";
import ListOfPurchaseOrderToReceive from "@/components/PurchaseOrderProductsToReceive/List.vue";

import ProductOrService from "@/views/ProductOrService/ProductOrService.vue";
import CreateEditProductOrService from "@/components/ProductOrService/CreateEdit.vue";
import ListOfProductOrService from "@/components/ProductOrService/List.vue";

import ReleaseNotes from "@/views/ReleaseNotes";
import Report from "@/views/Report/Report";

// import auth service
import AuthService from "@/_services/auth";

const authService = new AuthService();

// for requiring global auth
function requireAuth(to, from, next) {
  if (authService.isLoggedIn()) {
    next();
  } else {
    next("/login");
  }
}

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      beforeEnter: requireAuth,
      component: Home
    },
    {
      path: "/release-notes",
      name: "Release Notes",
      beforeEnter: requireAuth,
      component: ReleaseNotes
    },
    {
      path: "/reports",
      name: "Report",
      beforeEnter: requireAuth,
      component: Report
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/user-managements",
      beforeEnter: requireAuth,
      component: UserManagement,
      children: [
        {
          path: "/",
          component: ListOfUser,
          name: "List of Users"
        },
        {
          path: "create",
          component: CreateEditUser,
          name: "Create User"
        },
        {
          path: "edit/:userId",
          component: CreateEditUser,
          name: "Update User"
        },
        {
          path: "annual-quota/:userId",
          component: CreateEditAgentQuota,
          name: "User Annual Quota"
        }
      ]
    },
    {
      path: "/clients",
      beforeEnter: requireAuth,
      component: Client,
      children: [
        {
          path: "/",
          component: ListOfClient,
          name: "List of Clients"
        },
        {
          path: "create",
          component: CreateEditClient,
          name: "Create Client"
        },
        {
          path: "edit/:clientId",
          component: CreateEditClient,
          name: "Edit Client"
        }
      ]
    },
    {
      path: "/suppliers",
      beforeEnter: requireAuth,
      component: Supplier,
      children: [
        {
          path: "/",
          component: ListOfSupplier,
          name: "List of Suppliers"
        },
        {
          path: "create",
          component: CreateEditSupplier,
          name: "Create Supplier"
        },
        {
          path: "edit/:supplierId",
          component: CreateEditSupplier,
          name: "Edit Supplier"
        }
      ]
    },
    {
      path: "/po-requests",
      beforeEnter: requireAuth,
      component: PoRequest,
      children: [
        {
          path: "list/:pageSize/:byStatus/:searchQuery?",
          component: ListOfPoRequest,
          name: "List of PO Requests"
        },
        {
          path: "list-for-final-approval/:pageSize/:searchQuery?",
          component: ListForFinalApprovals,
          name: "List of PO Requests for Final Approval"
        },
        {
          path: "create",
          component: CreateEditPoRequest,
          name: "Create PO Request"
        },
        {
          path: "edit/:poRequestId",
          component: CreateEditPoRequest,
          name: "Edit PO Request"
        }
      ]
    },
    {
      path: "/ticketing-for-items",
      beforeEnter: requireAuth,
      component: TicketingForItem,
      children: [
        {
          path:
            "list/:page/:pageSize/:sow?/:itemType?/:progressStat?/:searchQuery?",
          component: ListOfTicketingForItem,
          name: "List of Ticketing for Item"
        },
        {
          path: "create",
          component: CreateEditTicketingForItem,
          name: "Create Ticketing for Item"
        },
        {
          path: "edit/:ticketingForItemId",
          component: CreateEditTicketingForItem,
          name: "Edit Ticketing for Item"
        }
      ]
    },
    {
      path: "/sales-quotes",
      beforeEnter: requireAuth,
      component: SalesQuote,
      children: [
        {
          path: "list/:pageSize/:searchQuery?",
          component: ListOfSalesQuote,
          name: "List of Sales Quote"
        },
        {
          path: "create",
          component: CreateEditSalesQuote,
          name: "Create Sales Quote"
        },
        {
          path: "edit/:salesQuoteId",
          component: CreateEditSalesQuote,
          name: "Edit Sales Quote"
        }
      ]
    },
    {
      path: "/pull-out-to-clients",
      beforeEnter: requireAuth,
      component: PullOutToClient,
      children: [
        {
          path: "/",
          component: ListOfPullOutToClient,
          name: "List of Pull Out to Client"
        },
        {
          path: "create",
          component: CreateEditPullOutToClient,
          name: "Create Pull Out to Client"
        },
        {
          path: "edit/:pullOutToClientId",
          component: CreateEditPullOutToClient,
          name: "Edit PullOut to Client"
        }
      ]
    },
    {
      path: "/deliveries",
      beforeEnter: requireAuth,
      component: Delivery,
      children: [
        {
          path: "list/:page/:pageSize/:searchQuery?",
          component: ListOfDelivery,
          name: "List of Delivery"
        },
        {
          path: "create",
          component: CreateEditDelivery,
          name: "Create Delivery"
        },
        {
          path: "edit/:deliveryId",
          component: CreateEditDelivery,
          name: "Edit Delivery"
        }
      ]
    },
    {
      path: "/billings",
      beforeEnter: requireAuth,
      component: Billing,
      children: [
        {
          path: "list/:page/:pageSize/:searchQuery?",
          component: ListOfBilling,
          name: "List of Billing"
        },
        // {
        //   path: "create",
        //   component: CreateEditBilling,
        //   name: "Create Billing"
        // },
        {
          path: "edit/:billingId",
          component: CreateEditBilling,
          name: "Edit Billing"
        }
      ]
    },
    {
      path: "/po-products-to-receive/:pageSize",
      beforeEnter: requireAuth,
      component: ListOfPurchaseOrderToReceive,
      name: "List of Purchase Order To Receive"
    },
    {
      path: "/purchase-orders",
      beforeEnter: requireAuth,
      component: PurchaseOrder,
      children: [
        {
          path: "list/:pageSize",
          component: ListOfPurchaseOrder,
          name: "List of Purchase Order"
        },
        {
          path: "create",
          component: CreateEditPurchaseOrder,
          name: "Create Purchase Order"
        },
        {
          path: "create-new",
          component: CreateEditPurchaseOrder2,
          name: "Create New Purchase Order"
        },
        {
          path: "edit/:purchaseOrderId",
          component: CreateEditPurchaseOrder2,
          name: "Edit Purchase Order"
        }
      ]
    },
    {
      path: "/products-and-services",
      beforeEnter: requireAuth,
      component: ProductOrService,
      children: [
        {
          path: "list/:pageSize",
          component: ListOfProductOrService,
          name: "List of Product/Service"
        },
        {
          path: "create",
          component: CreateEditProductOrService,
          name: "Create Product/Service"
        },
        {
          path: "edit/:productOrServiceId",
          component: CreateEditProductOrService,
          name: "Edit Product/Service"
        }
      ]
    }
  ]
});
